var styleDataHash = "639ecb3a";
const injectCss = () => {
  var css = `.GeM9I,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.sj6aC{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;width:100%}[dir] .sj6aC{background-color:#fff}[dir=ltr] .sj6aC,[dir=rtl] .sj6aC{padding-left:20px;padding-right:20px}.sj6aC>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "fontElementMap": "GeM9I",
  "container": "sj6aC"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
